import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [school, setSchool] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const storedSchool = localStorage.getItem('school');
    if (storedSchool) {
      setSchool(JSON.parse(storedSchool));
    }

    if (token) {
      fetchCurrentUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchCurrentUser = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(response.data);
    } catch (error) {
      console.error('Failed to fetch user:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const checkSchoolCode = async (schoolCode) => {
    const response = await axios.post(`${API}/auth/check-school`, { schoolCode });
    setSchool(response.data.school);
    localStorage.setItem('school', JSON.stringify(response.data.school));
    return response.data.school;
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token, user: userData } = response.data;
    setToken(access_token);
    setUser(userData);
    localStorage.setItem('token', access_token);
    return userData;
  };

  const logout = () => {
    setUser(null);
    setSchool(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('school');
  };

  const setInternalSchool = () => {
    const internalSchool = { id: 'SYSTEM', name: 'SchoolBird Internal', schoolCode: 'SYSTEM' };
    setSchool(internalSchool);
    localStorage.setItem('school', JSON.stringify(internalSchool));
  };

  return (
    <AuthContext.Provider value={{ user, school, loading, checkSchoolCode, login, logout, setInternalSchool }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
